/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';


/**
 * Returns list of security types.
 * @summary Security Types
 */
export const SecurityTypesResponseItem = zod.enum(['common', 'preferred', 'reit', 'etf', 'adr', 'right', 'warrants', 'units', 'tracking_stock', 'closed_end_fund'])
export const SecurityTypesResponse = zod.array(SecurityTypesResponseItem)

